"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs = __importStar(require("qs"));
var socket_io_client_1 = require("socket.io-client");
var EventRegistry_1 = __importDefault(require("./EventRegistry"));
var package_json_1 = __importDefault(require("../package.json"));
var MAX_RETRY_ATTEMPS = 10;
var ChatClient = /** @class */ (function () {
    function ChatClient(endpoint, token) {
        this.endpoint = 'http://localhost:4000';
        this.token = '';
        this.channels = [];
        this.eventRegistry = new EventRegistry_1.default();
        this.users = {};
        this.isDisconnected = false;
        this.lastJoinedChannelId = null;
        this.endpoint = endpoint;
        this.token = token;
        // TODO dont connect just initialize
        this.socket = socket_io_client_1.io(this.endpoint, {
            autoConnect: false,
            forceNew: true,
            transports: ['websocket'],
            query: {
                token: this.token,
            },
        });
    }
    ChatClient.prototype.listen = function () {
        var _this = this;
        this.listenToAppEvents();
        this.socket.on('connect', function () {
            // ...
            if (_this.isDisconnected) {
                setTimeout(function () {
                    if (_this.lastJoinedChannelId) {
                        _this.joinChannel(_this.lastJoinedChannelId);
                    }
                }, 5000);
                _this.isDisconnected = false;
            }
            _this.eventRegistry.emit('connect', {});
        });
        this.socket.on('connect_error', function (e) {
            // ...
        });
        this.socket.on('disconnect', function (data) {
            _this.isDisconnected = true;
        });
        // Listen on IO events
        this.socket.io.on('error', function (e) {
            // ...
        });
        this.socket.io.on('reconnect', function (attempt) {
            setTimeout(function () { return _this.eventRegistry.emit('reconnect', {}); }, 3000);
        });
        this.socket.io.on('reconnect_attempt', function (attempt) {
            if (attempt === MAX_RETRY_ATTEMPS) {
                _this.eventRegistry.emit('maxRetryAttemptsReached', {});
            }
        });
        this.socket.io.on('reconnect_error', function (e) {
            // ...
        });
        this.socket.io.on('reconnect_failed', function () {
            // ...
        });
        this.socket.io.on('ping', function () {
            // ...
        });
    };
    ChatClient.prototype.listenToAppEvents = function () {
        var _this = this;
        this.socket.on('message', function (data) {
            _this.eventRegistry.emit('message', data);
        });
        this.socket.on('acting', function (_a) {
            var userId = _a.userId, channelId = _a.channelId, lastActingAt = _a.lastActingAt, actingType = _a.actingType;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    this.eventRegistry.emit('acting', {
                        userId: userId,
                        channelId: channelId,
                        lastActingAt: lastActingAt,
                        actingType: actingType,
                    });
                    return [2 /*return*/];
                });
            });
        });
        this.socket.on('channelUpdate', function (data) {
            _this.eventRegistry.emit('channelUpdate', data);
        });
        this.socket.on('channelUpsert', function (data) {
            _this.eventRegistry.emit('channelUpsert', data);
        });
        this.socket.on('channelDelete', function (data) {
            _this.eventRegistry.emit('channelDelete', data);
        });
        this.socket.on('channelCreate', function (data) {
            _this.eventRegistry.emit('channelCreate', data);
        });
        this.socket.on('markedAllAsRead', function (data) {
            var upsert = {
                unreadMessageCount: 0,
                channelMembership: data.updatedChannelMembership,
            };
            _this.eventRegistry.emit('channelUpsert', {
                channelId: data.channelId,
                upsert: upsert,
            });
        });
        this.socket.on('userBlockChange', function (data) {
            _this.eventRegistry.emit('userBlockChange', data);
        });
        this.socket.on('messageDeleted', function (data) {
            _this.eventRegistry.emit('messageDeleted', data);
        });
    };
    ChatClient.prototype.connect = function () {
        this.listen();
        this.socket.open();
    };
    ChatClient.prototype.joinChannel = function (channelId) {
        this.lastJoinedChannelId = channelId;
        this.socket.emit('join-channel', { id: channelId });
    };
    ChatClient.prototype.leaveChannel = function (channelId) {
        this.lastJoinedChannelId = null;
        this.socket.emit('leave-channel', { id: channelId });
    };
    ChatClient.prototype.sendMessage = function (chatMessage, onBlockedHandler) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.socket.emit('message', chatMessage, function (status, message) {
                if (status === 403) {
                    return onBlockedHandler === null || onBlockedHandler === void 0 ? void 0 : onBlockedHandler(message);
                }
                resolve();
            });
            // when to reject? timeout maybe
        });
    };
    ChatClient.prototype.triggerUserActing = function (lastActingAt, channelId, actingType) {
        this.socket.emit('acting', {
            id: channelId,
            lastActingAt: lastActingAt,
            actingType: actingType,
        });
    };
    ChatClient.prototype.onUserActing = function (callback) {
        return this.eventRegistry.on('acting', callback);
    };
    ChatClient.prototype.onConnect = function (callback) {
        return this.eventRegistry.on('connect', callback);
    };
    ChatClient.prototype.onReconnect = function (callback) {
        return this.eventRegistry.on('reconnect', callback);
    };
    ChatClient.prototype.onMaxRetryAttemptsReached = function (callback) {
        return this.eventRegistry.on('maxRetryAttemptsReached', callback);
    };
    ChatClient.prototype.onDisconnect = function (callback) {
        return this.eventRegistry.on('disconnect', callback);
    };
    ChatClient.prototype.onAllNewMessage = function (callback) {
        return this.eventRegistry.on('message', callback);
    };
    ChatClient.prototype.onNewMessage = function (channelId, callback) {
        return this.eventRegistry.on('message', callback, function (message) { return message.channelId === channelId; });
    };
    ChatClient.prototype.onChannelUpdate = function (callback) {
        return this.eventRegistry.on('channelUpdate', callback);
    };
    ChatClient.prototype.onChannelUpsert = function (callback) {
        return this.eventRegistry.on('channelUpsert', callback);
    };
    ChatClient.prototype.onChannelCreate = function (callback) {
        return this.eventRegistry.on('channelCreate', callback);
    };
    ChatClient.prototype.onChannelDelete = function (callback) {
        return this.eventRegistry.on('channelDelete', callback);
    };
    ChatClient.prototype.onUserBlockChange = function (callback) {
        return this.eventRegistry.on('userBlockChange', callback);
    };
    ChatClient.prototype.onMessageDeleted = function (callback) {
        return this.eventRegistry.on('messageDeleted', callback);
    };
    ChatClient.prototype.emitMarkReadUntil = function (channelId, messageId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.socket.emit('markReadUntil', { channelId: channelId, messageId: messageId }, function (data) {
                    var upsert = {
                        unreadMessageCount: data.unreadMessageCount,
                        channelMembership: data.updatedChannelMembership,
                    };
                    _this.eventRegistry.emit('channelUpsert', {
                        channelId: channelId,
                        upsert: upsert,
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    ChatClient.prototype.getUnreadMessageCount = function (channel) {
        return __awaiter(this, void 0, void 0, function () {
            var unreadMessageCount, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.executeHTTP('GET', "/api/client/chat/channels/unread-count/" + channel.id, {}, {})];
                    case 1:
                        unreadMessageCount = (_a.sent()).count;
                        return [2 /*return*/, __assign(__assign({}, channel), { unreadMessageCount: unreadMessageCount })];
                    case 2:
                        error_1 = _a.sent();
                        console.log(error_1.message);
                        return [2 /*return*/, channel];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.loadEarlierChannels = function (earliestDate, size) {
        if (size === void 0) { size = 20; }
        return __awaiter(this, void 0, void 0, function () {
            var params, channels;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            filter: { skipEmpty: true, listed: true },
                            perPage: size,
                        };
                        if (earliestDate)
                            params.filter['lastActivityBefore'] = earliestDate;
                        return [4 /*yield*/, this.executeHTTP('GET', '/api/client/chat/channels', params, {})];
                    case 1:
                        channels = _a.sent();
                        return [2 /*return*/, channels];
                }
            });
        });
    };
    ChatClient.prototype.loadLaterChannels = function (latestDate, size) {
        if (size === void 0) { size = 20; }
        return __awaiter(this, void 0, void 0, function () {
            var params, channels;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            filter: { skipEmpty: true, listed: true },
                            perPage: size,
                        };
                        if (latestDate)
                            params.filter['updatedAfter'] = latestDate;
                        return [4 /*yield*/, this.executeHTTP('GET', '/api/client/chat/channels', params, {})];
                    case 1:
                        channels = _a.sent();
                        return [2 /*return*/, channels];
                }
            });
        });
    };
    ChatClient.prototype.getChannel = function (channelId, channelExternalId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            var filters, channels;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filters = { listed: false };
                        if (!(channelId || channelExternalId)) return [3 /*break*/, 2];
                        if (channelId)
                            filters['id'] = channelId;
                        if (channelExternalId)
                            filters['externalId'] = channelExternalId;
                        if (filter === null || filter === void 0 ? void 0 : filter.metadata)
                            filters['metadata'] = JSON.stringify(filter.metadata);
                        return [4 /*yield*/, this.executeHTTP('GET', '/api/client/chat/channels', { filter: __assign(__assign({}, filters), filter) }, {})];
                    case 1:
                        channels = _a.sent();
                        return [2 /*return*/, channels];
                    case 2: return [2 /*return*/, []];
                }
            });
        });
    };
    ChatClient.prototype.getChannels = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var filters, channels, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        filters = { listed: false };
                        if (filter === null || filter === void 0 ? void 0 : filter.metadata)
                            filters['metadata'] = JSON.stringify(filter.metadata);
                        return [4 /*yield*/, this.executeHTTP('GET', '/api/client/chat/channels', { filter: __assign(__assign({}, filters), filter), perPage: (filter === null || filter === void 0 ? void 0 : filter.perPage) || 100 }, {})];
                    case 1:
                        channels = _a.sent();
                        return [2 /*return*/, channels];
                    case 2:
                        error_2 = _a.sent();
                        console.log(error_2);
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.loadMessagesBeforeId = function (channelId, messageIdBefore, size) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.executeHTTP('GET', '/api/client/chat/messages', {
                        filter: {
                            channelId: channelId,
                            messageIdBefore: messageIdBefore,
                        },
                        perPage: size,
                    }, {})];
            });
        });
    };
    ChatClient.prototype.loadMessagesAfterId = function (channelId, messageIdAfter, size) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.executeHTTP('GET', '/api/client/chat/messages', {
                        filter: {
                            channelId: channelId,
                            messageIdAfter: messageIdAfter,
                        },
                        perPage: size,
                    }, {})];
            });
        });
    };
    ChatClient.prototype.loadEarlierMessages = function (channelId, earliestDate, size) {
        if (size === void 0) { size = 20; }
        return __awaiter(this, void 0, void 0, function () {
            var params, messages;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = { filter: { channelId: channelId }, perPage: size };
                        if (earliestDate)
                            params.filter['createdBefore'] = earliestDate;
                        return [4 /*yield*/, this.executeHTTP('GET', '/api/client/chat/messages', params, {})];
                    case 1:
                        messages = _a.sent();
                        return [2 /*return*/, messages];
                }
            });
        });
    };
    ChatClient.prototype.loadLaterMessages = function (channelId, latestDate, size) {
        if (size === void 0) { size = 20; }
        return __awaiter(this, void 0, void 0, function () {
            var params, messages;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = { filter: { channelId: channelId }, perPage: size };
                        if (latestDate)
                            params.filter['updatedAfter'] = latestDate;
                        return [4 /*yield*/, this.executeHTTP('GET', '/api/client/chat/messages', params, {})];
                    case 1:
                        messages = _a.sent();
                        return [2 /*return*/, messages];
                }
            });
        });
    };
    ChatClient.prototype.getUser = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var users;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        //check internal cache otherwise fetch from API
                        if (this.users[id]) {
                            return [2 /*return*/, this.users[id]];
                        }
                        return [4 /*yield*/, this.executeHTTP('GET', '/api/client/chat/users', { ids: [id] }, {})];
                    case 1:
                        users = _a.sent();
                        users.forEach(function (user) {
                            _this.users[user.id] = user;
                        });
                        return [2 /*return*/, this.users[id]];
                }
            });
        });
    };
    ChatClient.prototype.me = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.currentUser) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.executeHTTP('GET', '/api/client/chat/me', {}, {})];
                    case 1:
                        _a.currentUser = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.currentUser];
                }
            });
        });
    };
    ChatClient.prototype.sendAttachment = function (chatMessage, file) {
        return __awaiter(this, void 0, void 0, function () {
            var body;
            return __generator(this, function (_a) {
                body = new FormData();
                body.append('attachment', file);
                return [2 /*return*/, this.executeHTTP('POST', '/api/client/chat/sendMessage', __assign({}, chatMessage), body)];
            });
        });
    };
    ChatClient.prototype.blockUser = function (blockedId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.executeHTTP('PUT', "/api/client/chat/users/block/" + blockedId, {}, {})];
            });
        });
    };
    ChatClient.prototype.unBlockUser = function (blockedId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.executeHTTP('PUT', "/api/client/chat/users/unblock/" + blockedId, {}, {})];
            });
        });
    };
    ChatClient.prototype.getBlockedUsers = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.executeHTTP('GET', '/api/client/chat/users/blocked', {}, {})];
            });
        });
    };
    ChatClient.prototype.isBlockingMe = function (blockerId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.executeHTTP('GET', "/api/client/chat/users/isblockingme/" + blockerId, {}, {})];
            });
        });
    };
    ChatClient.prototype.archiveChannel = function (channelId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.executeHTTP('PUT', "/api/client/chat/channels/archive/" + channelId, {}, {})];
            });
        });
    };
    ChatClient.prototype.unArchiveChannel = function (channelId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.executeHTTP('PUT', "/api/client/chat/channels/unarchive/" + channelId, {}, {})];
            });
        });
    };
    ChatClient.prototype.getArchivedChannels = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.executeHTTP('GET', '/api/client/chat/channels/archived', {}, {})];
            });
        });
    };
    ChatClient.prototype.deleteMessage = function (messageId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.executeHTTP('DELETE', "/api/client/chat/messages/" + messageId, {}, {})];
            });
        });
    };
    ChatClient.prototype.getStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.executeHTTP('GET', '/status', {}, {})];
            });
        });
    };
    ChatClient.prototype.executeHTTP = function (method, path, urlParams, body) {
        return __awaiter(this, void 0, void 0, function () {
            var queryString, url, options, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryString = '';
                        if (urlParams) {
                            queryString = qs.stringify(__assign(__assign({}, urlParams), { sdkVersion: package_json_1.default.version }), { arrayFormat: 'brackets' });
                        }
                        url = "" + this.endpoint + path + "?" + queryString;
                        options = {
                            method: method,
                            headers: {
                                Authorization: "Bearer " + this.token,
                            },
                        };
                        if (method === 'POST' || method === 'PUT') {
                            options['body'] = body;
                        }
                        return [4 /*yield*/, fetch(url, options)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error(response.statusText);
                        }
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ChatClient;
}());
exports.default = ChatClient;
//# sourceMappingURL=ChatClient.js.map